import React, { useEffect, useState } from "react";
import styles from "./spinner.module.css";

export function SpinnerComponent({ avoidWait = false }) {
  const [text, setText] = useState("");
  const [showComponent, setShowComponent] = useState(avoidWait);

  useEffect(() => {
    let timeouts = [];
    const changeText = () => {
      setText("");

      timeouts.push(
        setTimeout(() => {
          setShowComponent(true);
        }, 1000),
      );

      timeouts.push(
        setTimeout(() => {
          setText("Cargando");
        }, 3000),
      );

      timeouts.push(
        setTimeout(() => {
          setText("Tecnología ya está en ello");
        }, 11000),
      );

      timeouts.push(
        setTimeout(() => {
          setText("Buscando hasta debajo de las piedras");
        }, 21000),
      );

      timeouts.push(
        setTimeout(() => {
          setText("Vale, esto se nos está resistiendo");
        }, 31000),
      );

      timeouts.push(
        setTimeout(() => {
          changeText();
        }, 41000),
      );
    };

    changeText();
    return () => {
      timeouts.forEach((timeoutId) => clearTimeout(timeoutId));
    };
  }, []);

  if (!showComponent) return null;

  return (
    <div className={styles.loadingInScroll}>
      <div className={styles.spinner} />
      {/* <p className={styles["loading-text2"]}>{text}<span></span></p> */}
      {text && (
        <p className={styles.loadingText}>
          {text}
          <span className={styles["loading-dots"]}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </p>
      )}
    </div>
  );
}
